import { createApp } from 'vue'
import TonePractice from '../components/TonePractice.vue'

export function mountTonePractice() {
  const el = document.getElementById('tone-practice-app')
  if (!el) return

  createApp(TonePractice, {
    contentUrl: el.dataset.contentUrl,
    contourUrl: el.dataset.contourUrl,
    referenceUrl: el.dataset.referenceUrl,
    customUrl: el.dataset.customUrl,
    backUrl: el.dataset.backUrl,
    billingUrl: el.dataset.billingUrl,
    subscribed: el.dataset.subscribed === 'true',
    startedLevels: JSON.parse(el.dataset.startedLevels || '[]'),
    initialDialect: el.dataset.dialect || 'south',
  }).mount(el)
}
